module.exports = __webpack_public_path__ + "img/Aershan-niu-bg.9a304711.jpg";